import cn from "@/lib/cn";
import { Tab } from "@headlessui/react";
import FAQTab from "./faq-tab";
import KnowledgeHubTab from "./knowledge-hub-tab";
import { Faq, KnowledgeHubResource } from "@/types/dto/category.dto";

function KnowledgeHubAndFAQTabs({
	faqs,
	knowledgeHubResources,
}: {
	faqs?: Faq[];
	knowledgeHubResources?: KnowledgeHubResource[];
}) {
	const tabs = ["FAQs", "Knowledge Hub"];

	return (
		<div className="mb-8">
			<Tab.Group>
				<Tab.List className="mb-4 flex">
					{tabs.map((tab, i) => (
						<Tab
							key={i}
							className={({ selected }) =>
								cn(
									"flex-none cursor-pointer px-4 py-2",
									selected
										? "border-b-4 border-brand-primary font-bold text-brand-primary outline-none"
										: "font-semibold text-black hover:bg-gray-100"
								)
							}
						>
							{tab}
						</Tab>
					))}
				</Tab.List>

				<Tab.Panels>
					<Tab.Panel>
						<FAQTab faqs={faqs} />
					</Tab.Panel>

					<Tab.Panel>
						<KnowledgeHubTab resources={knowledgeHubResources} />
					</Tab.Panel>
				</Tab.Panels>
			</Tab.Group>
		</div>
	);
}

export default KnowledgeHubAndFAQTabs;
